import * as THREE from 'three';

export const UNDER_LIGHT_PRESETS = [
  '#ffffff',
  '#ffe2b8',
  '#c8dcff',
  '#c1c1ff',
  '#ffcc4d',
  '#7fe0e6',
  '#ff8a7a',
  '#9be59b',
] as const;

export const UNDER_LIGHT_INTENSITY_MAX = 4;
export const UNDER_LIGHT_TILT_MIN = 5;

const PASTEL_SATURATION = 0.75;
const PASTEL_LIGHTNESS = 0.72;

/** A soft colour at this hue, in degrees, as the hue slider picks it. */
export function pastelAt(hue: number): string {
  return `#${new THREE.Color().setHSL(hue / 360, PASTEL_SATURATION, PASTEL_LIGHTNESS).getHexString()}`;
}

export function hueOf(color: string): number {
  return Math.round(new THREE.Color(color).getHSL({ h: 0, s: 0, l: 0 }).h * 360);
}
